import { IconButton, Stack, Typography } from "@mui/material";
import { SelectIcon } from "components/icon";
import { useTranslation } from "react-i18next";

const PasteButton = ({ label = null, sx = {}, clickEvent = null }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction={"row"}
      sx={{
        gap: 0,
        alignItems: "center",
        color: "#000",
        ...sx
      }}>
      <IconButton aria-label={t("refresh")} onClick={clickEvent}>
        <SelectIcon
          value={"pasteIcon"}
          selected={false}
          sx={{ fontSize: "1rem" }}
        />
      </IconButton>
      {label ? <Typography>{label}</Typography> : null}
    </Stack>
  );
};

export default PasteButton;
